var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVibrationOn = function SvgVibrationOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 8,
    height: 12,
    rx: 1,
    stroke: "#9AA0AB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 3,
    height: 4,
    rx: 0.5,
    stroke: "#9AA0AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.674 5A6.973 6.973 0 0 0 1 8c0 1.074.242 2.09.674 3M14.326 5c.432.91.674 1.926.674 3s-.242 2.09-.674 3",
    stroke: "#9AA0AB",
    strokeLinecap: "round"
  })));
};
export { SvgVibrationOn as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='4' y='2' width='8' height='12' rx='1' stroke='%239AA0AB'/%3E %3Crect x='6.5' y='4.5' width='3' height='4' rx='0.5' stroke='%239AA0AB'/%3E %3Cpath d='M1.67365 5C1.2417 5.90927 1 6.92643 1 8.00004C1 9.07366 1.2417 10.0908 1.67365 11.0001' stroke='%239AA0AB' stroke-linecap='round'/%3E %3Cpath d='M14.3263 5C14.7583 5.90927 15 6.92643 15 8.00004C15 9.07366 14.7583 10.0908 14.3263 11.0001' stroke='%239AA0AB' stroke-linecap='round'/%3E %3C/svg%3E";